// extracted by mini-css-extract-plugin
export default {"text":"pillStyles_text__sWh8X"};